export default __webpack_public_path__ + "static/media/Ouro.511c7ba7.mp4";